<template>
  <v-container fluid>
    <v-tabs>
      <v-tab to="/profil">
        Mon profil
      </v-tab>
      <v-tab v-if="user.features.find((map) => map == 'stormwatch')" to="/profil/stormwatch">
        Stormwatch
      </v-tab>
    </v-tabs>
    <router-view />
    <v-footer class="pb-16">
      <v-container fluid>
        <v-col cols=12>
          <a href="https://www.previmeteo.com/conditions-generales.php#cgv" target="blank">Condition d'utilisation</a><br/>
          <a href="https://www.previmeteo.com/conditions-generales.php" target="blank">Politique de confidentialité</a><br/>
          v.{{version}}
        </v-col>
      </v-container>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import {version} from '../../package.json';
export default {
  computed:{
    ...mapState(["user"])
  },
  data:()=>({
      version:version
  })
};
</script>

<style>
</style>
